<template>
  <div
    class="fixed top-0 left-1/2 z-50 -translate-x-1/2 transform rounded-4 bg-white p-5 shadow-sm"
  >
    <div class="flex items-center space-x-40">
      <div class="flex items-center space-x-2">
        <div
          class="flex items-center justify-center rounded-full bg-gray-100"
          :class="itemsNumberStyle.size"
        >
          <span
            class="rounded-full font-semibold text-label"
            :class="itemsNumberStyle.textSize"
            data-cy="deals-selected-count"
          >
            {{ ids.length }}
          </span>
        </div>
        <span class="text-label">{{ $t("COMMON.SELECTED") }}</span>
      </div>
      <div
        class="short-divider flex items-center justify-start space-x-4 divide-x"
      >
        <send-sms-button
          :application-ids="ids"
          @sms:sent="emit('panel:close')"
        />
        <send-emails-button
          :application-ids="ids"
          @emails:sent="emit('panel:close')"
        />
        <run-backtest-report-button
          :application-ids="ids"
          @report:redirect="emit('panel:close')"
        />
        <run-deals-do-button
          :application-ids="ids"
          @run:execute="emit('panel:close')"
        />
        <trigger-webhooks-button :application-ids="ids" />
      </div>
      <div
        v-tooltip="$t('COMMON.MULTISELECT_OFF')"
        class="cursor-pointer rounded-4 p-2 hover:bg-gray-100"
      >
        <icon-base :icon="IconX" @click="emit('panel:close')" />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { type PropType, computed } from "vue";
</script>
<script setup lang="ts">
import RunDealsDoButton from "@/components/deals/dataOrchestration/run/RunDealsDoButton.vue";
import IconX from "@/components/icons/deals/IconX.vue";
import RunBacktestReportButton from "@/views/deals/components/controlPanel/RunBacktestReportButton.vue";
import SendEmailsButton from "@/views/deals/components/controlPanel/SendEmailsButton.vue";
import SendSmsButton from "@/views/deals/components/controlPanel/SendSmsButton.vue";
import TriggerWebhooksButton from "@/views/deals/components/controlPanel/TriggerWebhooksButton.vue";

const props = defineProps({
  ids: {
    type: Array as PropType<string[]>,
    required: true,
  },
});

const emit = defineEmits<{
  "panel:close": [];
}>();

const itemsNumberStyle = computed(() => {
  if (props.ids.length > 10) {
    return {
      size: "w-8 h-8",
      textSize: "text-xs",
    };
  }
  if (props.ids.length > 100) {
    return {
      size: "w-12 h-12",
      textSize: "text-xxs",
    };
  }
  return {
    size: "w-6 h-6",
    textSize: "text-sm",
  };
});
</script>

<style scoped>
@reference "@/assets/tailwind.css";

.short-divider > div:not(:first-child) {
  @apply pl-4;
}
</style>
